export default __webpack_public_path__ + "static/media/up_white.66b9a70a.svg";